import React, { Component } from 'react';
import { connect } from 'react-redux';

import Modal from '../../../../components/Modal';
import Select from '../../../../components/Select';
import RadioGroup, { Radio } from '../../../../components/RadioGroup';
import { getRegions, getUfs } from '../../../../redux/region';

import Breadcrumb from './Breadcrumb';
import Form from './Form';

// map

const filters = {
  ALL: 'ALL',
  SELECT_REGIONS: 'SELECT_REGIONS',
  SELECT_UFS: 'SELECT_UFS',
};

class DashboardCompletedFilterRegionModal extends Component {
  constructor(props) {
    super(props);

    const isCustom =
      props.selectedRegions.length > 0 || props.selectedUfs.length > 0;

    this.state = {
      regions: props.selectedRegions || [],
      ufs: props.selectedUfs || [],
      isCustom,
      selectedFilter:
        props.selectedRegions.length > 0
          ? filters.SELECT_REGIONS
          : props.selectedUfs.length > 0
            ? filters.SELECT_UFS
            : filters.ALL,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getRegions());
    dispatch(getUfs());
  }

  _changeFilter = (type) => {
    if (type === filters.SELECT_REGIONS || type === filters.SELECT_UFS) {
      this.setState({
        isCustom: true,
        selectedFilter: type,
      });
    } else {
      this.props.onApply([], []);
    }
  };

  _mapListToOptions = () => {
    if (this.state.selectedFilter === filters.SELECT_REGIONS) {
      return this.props.regionsList.map(region => ({
        value: region.id,
        label: region.value,
      }));
    }

    return this.props.ufsList.map(uf => ({
      value: uf,
      label: uf,
    }));
  };

  _handleChange = (value) => {
    const valueKey =
      this.state.selectedFilter === filters.SELECT_REGIONS ? 'regions' : 'ufs';

    this.setState({
      [valueKey]: value.map(v => v.value),
    });
  };

  _submit = () => {
    if (this.state.selectedFilter === filters.SELECT_REGIONS) {
      this.props.onApply(this.state.regions, []);
    } else {
      // STATES
      this.props.onApply([], this.state.ufs);
    }
  };

  _goBack = () => {
    this.setState({ isCustom: false });
  };

  _renderContent = () => {
    const { isCustom, selectedFilter } = this.state;

    if (isCustom) {
      const currentText =
        selectedFilter === filters.SELECT_REGIONS
          ? 'Selecionar regiões'
          : 'Selecionar estados';
      const selectValue =
        selectedFilter === filters.SELECT_REGIONS
          ? this.state.regions
          : this.state.ufs;

      return (
        <div>
          <Breadcrumb
            onBack={this._goBack}
            prev="Todos os filtros"
            current={currentText}
          />
          <Form onSubmit={this._submit} submitText="Aplicar">
            <Select
              options={this._mapListToOptions()}
              value={selectValue}
              onChange={this._handleChange}
              closeOnSelect={false}
              multi
            />
          </Form>
        </div>
      );
    }

    return (
      <RadioGroup value={selectedFilter} onChangeValue={this._changeFilter}>
        <Radio value={filters.ALL} label="Todas as regiões" />
        <Radio value={filters.SELECT_REGIONS} label="Selecionar regiões" />
        <Radio value={filters.SELECT_UFS} label="Selecionar estados" />
      </RadioGroup>
    );
  };

  render() {
    return (
      <Modal
        title="Selecionar regiões"
        size="small"
        onBackdropClick={this.props.onBackdropClick}
      >
        {this._renderContent()}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  regionsList: state.region.regions.list,
  ufsList: state.region.ufs.list,
});

export default connect(mapStateToProps)(DashboardCompletedFilterRegionModal);
